import { FC } from 'react'
import { ConfirmationAppDialog } from '../../../components'
import { BulkInvoiceAction } from './Services'

export interface BulkInvoiceActionConfirmProps {
  open: boolean
  action: BulkInvoiceAction | null
  count: number
  loading?: boolean
  onClose: () => void
  onConfirm: () => void
}

export const BulkInvoiceActionConfirm: FC<BulkInvoiceActionConfirmProps> = ({
  open,
  action,
  count,
  loading = false,
  onClose,
  onConfirm,
}) => {
  if (!action) {
    return null
  }

  const isDelete = action === 'DELETE'
  const title = isDelete ? 'Delete Invoices' : 'Send on Email'
  const message = isDelete
    ? `Delete ${count} selected invoice(s)? This cannot be undone.`
    : `Send ${count} selected invoice(s) on email?`

  return (
    <ConfirmationAppDialog
      id="bulk-invoice-action"
      title={title}
      onClose={onClose}
      close={!open}
      dialogActionsButtons={[
        {
          text: 'Cancel',
          color: 'success',
          variant: 'outlined',
          onClickHandler: onClose,
        },
        {
          text: loading ? 'Please wait...' : 'Confirm',
          color: isDelete ? 'error' : 'primary',
          variant: 'contained',
          onClickHandler: loading ? () => {} : onConfirm,
        },
      ]}
    >
      {message}
    </ConfirmationAppDialog>
  )
}

export default BulkInvoiceActionConfirm
